import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon SavedCartsIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const SavedCartsIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path
        d="M0.802124 2H5.21939L5.83691 4.75499M5.83691 4.75499C5.83691 4.75499 22.7359 4.57102 22.9309 4.75499C23.0911 4.90603 20.1434 14.1551 20.1434 14.1551C20.1434 14.1551 20.1434 14.1551 20.1375 14.1551C20.1375 14.1551 18.4225 14.1569 17.9099 14.1551C15.4044 14.146 9.14023 14.1185 7.64712 14.1551M5.83691 4.75499L7.64712 14.1551M7.64712 14.1551C5.85503 14.1991 5.6482 16.5027 7.64712 16.7184C7.99102 16.7433 20.4431 16.7184 20.4431 16.7184"
        stroke="#503291"
        strokeLinecap="round"
      />
      <path
        d="M9.45325 18.2944C10.3384 18.2944 11.0557 19.0119 11.0558 19.897C11.0558 20.7821 10.3384 21.4995 9.45325 21.4995C8.56817 21.4994 7.85071 20.7821 7.85071 19.897C7.8508 19.012 8.56822 18.2945 9.45325 18.2944Z"
        stroke="#503291"
      />
      <path
        d="M17.8221 18.2944C18.7073 18.2944 19.4246 19.0119 19.4247 19.897C19.4247 20.7821 18.7073 21.4995 17.8221 21.4995C16.9371 21.4994 16.2196 20.7821 16.2196 19.897C16.2197 19.012 16.9371 18.2945 17.8221 18.2944Z"
        stroke="#503291"
      />
    </Icon>
  )
}
export default SavedCartsIcon
